/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
/// ROUTER ///
import { useNavigate } from "react-router-dom";
/// ACTIONS ///
import { setBreadcrumbs } from "api/actions/ui/set";
/// MUI ///
import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
/// COMPONENTS ///
import PageTitle from "components/universal/page/title";
/// FM ///
import { motion } from "framer-motion";
/// STYLES ///
import { content_container_style } from "styles/universal/page";
import { header_style } from "styles/universal/section_header";
import { mat_tile_style } from "styles/material";
/// MOTION ///
import { m_init_page } from "motion/page";
import { m_anim_page } from "motion/page";
import { m_exit_page } from "motion/page";
import { page_trans } from "motion/page";
import { mat_tile_anim } from "styles/material";
/// FA ///
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/// ICONS ///
import { faCompress } from "@fortawesome/free-solid-svg-icons";
import { faDiamond } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
/// VALUES ///
import { QUARTZ } from "values/material";
import { ULTRA_COMPACT } from "values/material";
import { NATURAL_STONE } from "values/material";
import { PRINTED_QUARTZ } from "values/material";
/// BREADCRUMBS ///
import { material_list } from "values/breadcrumbs/materials/shop";

export default function ShopMaterialDashboard() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setBreadcrumbs([material_list]));
  }, [dispatch]);

  return (
    <motion.div initial={m_init_page} exit={m_exit_page} animate={m_anim_page} transition={page_trans} style={content_container_style}>
      <Grid container>
        <Grid container item xs={12} md={9} lg={6}>
          <PageTitle title="Materials" endProps={
            <Box display="flex" alignItems="center" flexDirection="row">
            </Box>
          } />
          <Grid item xs={12}>
            <Box sx={header_style}></Box>
          </Grid>
          <Box display="flex" flexDirection="row" gap="20px" justifyContent="space-evenly" alignItems="center" marginTop="10px" width="100%" paddingTop="25px">
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(`${QUARTZ}`)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Quartz
              </Typography>
              <FontAwesomeIcon icon={faDiamond} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.6 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(`${ULTRA_COMPACT}`)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Ultra Compact
              </Typography>
              <FontAwesomeIcon icon={faCompress} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.6 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(`${NATURAL_STONE}`)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Natural Stone
              </Typography>
              <FontAwesomeIcon icon={faSquare} size="2xl" />
            </motion.button>
          </Box>
        </Grid>
      </Grid>
    </motion.div>
  )
}
